import { useLocation, Outlet } from 'react-router-dom';
import { memo } from 'react';
import Home from '@/pages/home/page';
import History from '@/pages/history/page';
import AIAssistant from '@/pages/ai-assistant/page';
import Profile from '@/pages/profile/page';

const tabRoutes = [
  { path: '/', id: 'home' as const, component: Home },
  { path: '/history', id: 'history' as const, component: History },
  { path: '/ai-assistant', id: 'ai' as const, component: AIAssistant },
  { path: '/profile', id: 'profile' as const, component: Profile },
];

const tabPaths = tabRoutes.map((t) => t.path);

export { tabPaths };

function TabContent() {
  const location = useLocation();
  const activeId = tabRoutes.find((t) => t.path === location.pathname)?.id ?? 'home';

  return (
    <div className="relative w-full flex-1 flex flex-col min-h-0">
      {tabRoutes.map(({ id, component: Component }) => {
        const isActive = id === activeId;
        return (
          <div
            key={id}
            className="w-full flex-1 flex flex-col min-h-0"
            style={{ display: isActive ? 'flex' : 'none' }}
            aria-hidden={!isActive}
          >
            <Component />
          </div>
        );
      })}
    </div>
  );
}

interface TabOrOutletProps {
  isTabPath: boolean;
}

function TabOrOutlet({ isTabPath }: TabOrOutletProps) {
  if (isTabPath) {
    return <TabContent />;
  }
  return <Outlet />;
}

export default memo(TabOrOutlet);